import { render, staticRenderFns } from "./ComprometimentoReprovar.vue?vue&type=template&id=73b97063"
import script from "./ComprometimentoReprovar.vue?vue&type=script&lang=js"
export * from "./ComprometimentoReprovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports